module.exports = __webpack_public_path__ + "img/banner-top.b7e93078.webp";